import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {MenuComponent} from '../core/utils/menu/menu.component';

const testingRoutes: Routes = [
  {path: '', component: MenuComponent}
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(testingRoutes)
  ]
})
export class TestingRoutingModule {
}
